import { z } from 'zod';
import { jobSearchSchema } from './job';

/** Bounds per-seeker fan-out at match time. */
export const MAX_SAVED_SEARCHES = 10;

/**
 * The filters a saved search freezes.
 *
 * Pagination is stripped: an alert is "these criteria", not "page 2 of these
 * criteria", and storing a page number would silently skip matches.
 */
export const savedSearchFiltersSchema = jobSearchSchema.omit({
  page: true,
  limit: true,
  sortBy: true,
  sortOrder: true,
});
export type SavedSearchFilters = z.infer<typeof savedSearchFiltersSchema>;

export const saveSearchSchema = z.object({
  name: z.string().trim().min(2, 'Name this alert').max(80),
  filters: savedSearchFiltersSchema,
});
export type SaveSearchInput = z.infer<typeof saveSearchSchema>;

export const updateAlertSchema = z
  .object({
    name: z.string().trim().min(2).max(80).optional(),
    isActive: z.boolean().optional(),
  })
  .refine((v) => v.name !== undefined || v.isActive !== undefined, {
    message: 'Nothing to change',
  });
export type UpdateAlertInput = z.infer<typeof updateAlertSchema>;
